import jQuery from "jquery";

export let GPMisc = {
    getContentBounds: function (ctx, w, h) {
        var idata = ctx.getImageData(0, 0, w, h),      // get image data for canvas
            buffer = idata.data,                       // get buffer (unnes. step)
            buffer32 = new Uint32Array(buffer.buffer), // get a 32-bit representation
            x, y,                                      // iterators
            x1 = w, y1 = h, x2 = 0, y2 = 0;            // min/max values

        // get left edge
        outerloop:
        for(x = 0; x < w; x++) {                   // 0 to width
            for(y = 0; y < h; y++) {                       // line by line
                if (buffer32[x + y * w] > 0) {         // non-transparent pixel?
                    x1 = x; break outerloop
                }
            }
        }
        // get right edge
        outerloop:
        for(x = w - 1; x >= 0; x--) {                  // from width to 0
            for(y = 0; y < h; y++) {                       // line by line
                if (buffer32[x + y * w] > 0) {
                    x2 = x; break outerloop
                }
            }
        }
        // get top edge
        outerloop:
        for(y = 0; y < h; y++) {
            for(x = 0; x < w; x++) {
                if (buffer32[x + y * w] > 0) {
                    y1 = y; break outerloop
                }
            }
        }

        // get bottom edge
        outerloop:
        for(y = h - 1; y >= 0; y--) {
            for(x = 0; x < w; x++) {
                if (buffer32[x + y * w] > 0) {
                    y2 = y; break outerloop
                }
            }
        }
        return [x1,y1,x2,y2]
    },

    /**
     *
     * @param {string} types - e.g 'image/jpeg,image/png,image/heic'
     * @return {Promise<File>}
     */
    askForFile: function(types) {
        return new Promise(resolve => {
            function fileSelected(e) {
                if(e.target.files.length) {
                    var f = e.target.files[0];
                    resolve(f);
                }
            }

            jQuery('#file-input').val("");
            jQuery('#file-input').off().on('change', fileSelected).attr('accept', types);
            jQuery('#file-input').click();
        });
    },

    blobToBase64: function(blob) {
        return new Promise((resolve, _) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result);
            reader.readAsDataURL(blob);
        });
    }
,
    /**
     * Loads jpg/png/heic from file
     *
     * @param {File} file
     * @return {Promise<string>} - base64 image
     */
    loadImageFile: function(file) {
        return new Promise(resolve => {
            var name = file.name;
            if (name.match(/(\.jpeg$)|(\.jpg$)|(\.webp$)|(\.png$)/i)) {
                var reader = new FileReader();
                reader.onload = function(e) {
                    resolve(reader.result);
                };
                reader.readAsDataURL(file);
            }

            if (name.match(/(\.heic$)/i)) {
                var processHeic = function() {
                    heic2any({
                        blob: file,
                        quality: 0.5,
                        toType: "image/jpeg"
                    }).then(async (conversionResult)=> {
                        let b64 = await GPMisc.blobToBase64(conversionResult);
                        resolve(b64);
                    })
                }
                if (typeof heic2any === "undefined")
                    jQuery.ajax({
                      url: 'js/heic2any.min.js',
                      dataType: "script"
                    }).then(processHeic)
                else
                    processHeic();
            }
        })
    },

    createFileFromPath: async function (path){
      let response = await fetch(path);
      let data = await response.blob();
      let metadata = {
          type: data.type
      }
      return new File([data], path, metadata);
    },


    detectOS: function () {
        var osDetect = {
        "Win32": "win",
        "Windows": "win",
        "Mac68K": "mac",
        "MacPPC": "mac",
        "MacIntel": "mac",
        "Macintosh": "mac"
        };

        if (osDetect[navigator.platform])
            return osDetect[navigator.platform];
        else
            return "win";
    },

    detectBrowser: function () {
        // Opera 8.0+
        if ((!!window.opr && !!opr.addons) || !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0) return "opera";

        // Firefox 1.0+
        if (typeof InstallTrigger !== 'undefined') return "ff";

        // Safari 3.0+ "[object HTMLElementConstructor]"
        if (/constructor/i.test(window.HTMLElement) || (function (p) { return p.toString() === "[object SafariRemoteNotification]"; })(!window['safari'] || (typeof safari !== 'undefined' && safari.pushNotification))) return "safari";

        // Internet Explorer 6-11
        if (/*@cc_on!@*/false || !!document.documentMode) return "ie";

        // Edge 20+
        var isIE = !isIE && !!window.StyleMedia;
        if (isIE) return "ie";

        return "chrome";
    },

     iOS: function() {
        return [
                'iPad Simulator',
                'iPhone Simulator',
                'iPod Simulator',
                'iPad',
                'iPhone',
                'iPod'
            ].includes(navigator.platform)
            // iPad on iOS 13 detection
            || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
    },

    roman: ["I","II","III","IV","V","VI","VII","VIII","IX","X","XI","XII"]
};

